<template>
  <div class="d-flex flex-column pt-10">
    <h2 class="align-self-center mt-5">Step 2. Questionnaire</h2>

    <v-form @submit.prevent="submit" class="d-flex flex-column mt-12">
      <div class="d-flex">
        <div class="d-flex flex-column flex-grow-1 px-10">
          <p class="font-weight-bold">4. Travel History</p>
          <v-radio-group
            v-model="travelHistory.visited"
            class="staticWidth"
            label="History of travel/visit/work in other countries with a known COVID-19 transmission 14 days before the onset of your signs and symptoms"
          >
            <v-radio :value="true" label="Yes"></v-radio>
            <v-radio :value="false" label="No"></v-radio>
          </v-radio-group>
          <v-text-field
            v-model="travelHistory.port"
            class="flex-grow-0 staticWidth"
            label="Port (Country) of exit"
          ></v-text-field>
          <v-text-field
            v-model="travelHistory.vessel"
            class="flex-grow-0 staticWidth"
            label="Airline/Sea vessel"
          ></v-text-field>
          <v-text-field
            v-model="travelHistory.number"
            class="flex-grow-0 staticWidth"
            label="Flight/Vessel number"
          ></v-text-field>
          <v-text-field
            v-model="travelHistory.departureDate"
            class="flex-grow-0 staticWidth"
            label="Date of Departure (mm/dd/yyyy)"
          ></v-text-field>
          <v-text-field
            v-model="travelHistory.arrivalDate"
            class="flex-grow-0 staticWidth"
            label="Date of Arrival in Philippines"
          ></v-text-field>

          <p class="font-weight-bold">5. PExposure History</p>
          <v-radio-group
            v-model="exposureHistory.history"
            class="staticWidth"
            label="History of Exposure to Known COVID-19 editingShippingTest 14 days before the onset of signs and symptoms"
          >
            <v-radio :value="true" label="Yes"></v-radio>
            <v-radio :value="false" label="No"></v-radio>
            <v-radio :value="null" label="Unknown"></v-radio>
          </v-radio-group>
          <v-text-field
            v-model="exposureHistory.historyDate"
            class="flex-grow-0 staticWidth"
            label="If yes: Date of contact with known COVID-19 editingShippingTest(mm/dd/yyyy)"
          ></v-text-field>
          <v-radio-group
            v-model="exposureHistory.place"
            class="staticWidth"
            label="Have you been in a place with a known COVID-19 transmission 14 days before the onset of signs and symptoms?"
          >
            <v-radio :value="true" label="Yes"></v-radio>
            <v-radio :value="false" label="No"></v-radio>
            <v-radio :value="null" label="Unknown"></v-radio>
          </v-radio-group>

          <v-radio-group
            v-model="exposureHistory.placeType"
            class="staticWidth"
            label="If yes: Place"
          >
            <v-radio value="workPlace" label="Work Place"></v-radio>
            <v-radio value="socialGathering" label="Social gathering"></v-radio>
            <v-radio value="healthFacility" label="Health facility"></v-radio>
            <v-radio value="religiousGathering" label="Religious gathering"></v-radio>
            <v-radio value="others" label="Others"></v-radio>
          </v-radio-group>

          <v-text-field
            v-model="exposureHistory.placeDate"
            class="flex-grow-0 staticWidth"
            label="Date of when you have been in that place"
          ></v-text-field>
          <v-text-field
            v-model="exposureHistory.placeName"
            class="flex-grow-0 staticWidth"
            label="Name of the place"
          ></v-text-field>
        </div>

        <div class="d-flex flex-grow-1 flex-column px-10">
          <p class="font-weight-bold">6. Clinical Information</p>
          
          <v-radio-group
            v-model="clinicalInformation.disposition"
            class="staticWidth"
            label="Disposition at Time of report"
          >
            <v-radio value="inpatient" label="Inpatient"></v-radio>
            <v-radio value="outpatient" label="Outpatient"></v-radio>
            <v-radio value="discharged" label="Discharged"></v-radio>
            <v-radio value="died" label="Died"></v-radio>
            <v-radio value="unknown" label="Unknown"></v-radio>
          </v-radio-group>

          <v-text-field
            v-model="clinicalInformation.dateOfIllness"
            class="flex-grow-0 staticWidth"
            label="Date of Onset of illness (mm/dd/yyyy)"
          ></v-text-field>
          <v-text-field
            v-model="clinicalInformation.dateOfAddmission"
            class="flex-grow-0 staticWidth"
            label="Date of Addmission/Consulation (mm/dd/yyyy)"
          ></v-text-field>

          <v-text-field
            v-model="clinicalInformation.fever"
            class="flex-grow-0 staticWidth"
            label="Fever"
          ></v-text-field>
          <v-checkbox v-model="clinicalInformation.cough" class="ma-0 pa-0" label="Cough"></v-checkbox>
          <v-checkbox
            v-model="clinicalInformation.soreThroat"
            class="ma-0 pa-0"
            label="Sore throat"
          ></v-checkbox>
          <v-checkbox v-model="clinicalInformation.colds" class="ma-0 pa-0" label="Colds"></v-checkbox>
          <v-checkbox
            v-model="clinicalInformation.breathShortness"
            class="ma-0 pa-0"
            label="Shortness/difficulty of breathing"
          ></v-checkbox>
          <v-text-field
            v-model="clinicalInformation.otherSymptoms"
            class="flex-grow-0 staticWidth"
            label="Other signs/symptoms, specify"
          ></v-text-field>
          <v-radio-group
            v-model="clinicalInformation.otherIllnessHistory"
            label="Is there any history of other illnes?"
          >
            <v-radio :value="true" label="Yes"></v-radio>
            <v-radio :value="false" label="No"></v-radio>
          </v-radio-group>
          <v-text-field
            v-model="clinicalInformation.otherIllnessHistoryDescription"
            class="flex-grow-0 staticWidth"
            label="If Yes, specify"
          ></v-text-field>
          <v-radio-group v-model="clinicalInformation.chestCray" label="Chest C-ray done?">
            <v-radio :value="true" label="Yes"></v-radio>
            <v-radio :value="false" label="No"></v-radio>
          </v-radio-group>

          <v-text-field
            v-model="clinicalInformation.chestCrayDate"
            class="flex-grow-0 staticWidth"
            label="If yes, when?"
          ></v-text-field>

          <v-radio-group v-model="clinicalInformation.pregnant" label="Are you pregnant">
            <v-radio :value="true" label="Yes"></v-radio>
            <v-radio :value="false" label="No"></v-radio>
          </v-radio-group>

          <v-text-field
            v-model="clinicalInformation.lmp"
            class="flex-grow-0 staticWidth"
            label="LMP"
          ></v-text-field>
          <v-radio-group v-model="clinicalInformation.highRisk" label="Assessed as High Risk?">
            <v-radio :value="true" label="Yes"></v-radio>
            <v-radio :value="false" label="No"></v-radio>
          </v-radio-group>

          <v-radio-group v-model="clinicalInformation.pneumonia" label="CXR Results: Pneumonia">
            <v-radio :value="true" label="Yes"></v-radio>
            <v-radio :value="false" label="No"></v-radio>
            <v-radio :value="null" label="Pending"></v-radio>
          </v-radio-group>

          <v-text-field
            v-model="clinicalInformation.radiologicFindings"
            class="flex-grow-0 staticWidth"
            label="Other Radiologic Findings"
          ></v-text-field>
        </div>
      </div>

      <v-btn
        color="primary"
        class="buttonText align-self-center my-10"
        width="200"
        rounded
        depressed
        type="submit"
      >Save & Proceed</v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      travelHistory: {
        visited: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.travelHistory?.visited,
        port: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.travelHistory?.port,
        vessel: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.travelHistory?.vessel,
        number: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.travelHistory?.number,
        departuteDate: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.travelHistory?.departuteDate,
        arrivalDate: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.travelHistory?.arrivalDate,
      },

      exposureHistory: {
        history: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.exposureHistory?.history,
        historyDate: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.exposureHistory?.historyDate,
        place: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.exposureHistory?.place,
        placeType: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.exposureHistory?.placeType,
        placeDate: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.exposureHistory?.placeDate,
        placeName: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.exposureHistory?.placeName,
      },

      clinicalInformation: {
        disposition: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.clinicalInformation?.disposition,
        dateOfIllness: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.clinicalInformation?.dateOfIllness,
        dateOfAddmission: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.clinicalInformation?.dateOfAddmission,
        fever: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.clinicalInformation?.fever,
        cough: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.clinicalInformation?.cough,
        soreThroat: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.clinicalInformation?.soreThroat,
        colds: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.clinicalInformation?.colds,
        breathShortness: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.clinicalInformation?.breathShortness,
        otherSymptoms: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.clinicalInformation?.otherSymptoms,
        otherIllnessHistory: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.clinicalInformation?.otherIllnessHistory,
        otherIllnessHistoryDescription: this.$store.state.frontDesk
          .editingShippingTest?.formJsonText?.clinicalInformation
          ?.otherIllnessHistoryDescription,
        chestCray: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.clinicalInformation?.chestCray,
        chestCrayDate: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.clinicalInformation?.chestCrayDate,
        pregnant: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.clinicalInformation?.pregnant,
        lmp: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.clinicalInformation?.lmp,
        highRisk: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.clinicalInformation?.highRisk,
        pneumonia: this.$store.state.frontDesk.editingShippingTest?.formJsonText
          ?.clinicalInformation?.pneumonia,
        radiologicFindings: this.$store.state.frontDesk.editingShippingTest
          ?.formJsonText?.clinicalInformation?.radiologicFindings,
      },
    };
  },

  methods: {
    submit() {
      const credentials = {
        travelHistory: this.travelHistory,
        exposureHistory: this.exposureHistory,
        clinicalInformation: this.clinicalInformation,
      };

      this.$store.dispatch("editShippingTestSecond", credentials);
    },
  },
};
</script>

<style lang="scss" scoped>
.staticWidth {
  width: 400px;
}
</style>